import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import HeadLogo from '../Assets/Oolook_logo.png';
import "react-toastify/dist/ReactToastify.css";

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        if (!email.trim()) {
            toast.error("Please enter your email address.");
            return;
        }

        setIsLoading(true);
        try {
            await axios.put(
                `${process.env.REACT_APP_BACKEND_API}/user/forgot_password`,
                { email_id: email }
            );
            localStorage.setItem("Email", email.trim().toLowerCase());
            toast.success('Reset link sent! Please check your email.');
            // Navigate to a confirmation screen after success
            navigate('/forgot-password-confirmation');
        } catch (err) {
            toast.error(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <ToastContainer position="top-right" autoClose={5000} />
            <div className="auth-card auth-shell">
                <img src={HeadLogo} alt="Oolook Logo" className="mx-auto h-12 w-auto mb-6" />
                <h2 className="text-center text-2xl font-bold text-neutral-dark mb-2">Forgot Your Password?</h2>
                <p className="text-center text-sm text-neutral-muted mb-8">
                    No problem. Enter your email address below, and we'll send you a link to reset it.
                </p>

                <form onSubmit={handleForgotPassword} className="space-y-6">
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-neutral-muted mb-1">
                            Email Address
                        </label>
                        <input
                            type="email"
                            id="email"
                            placeholder="you@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="form-input"
                        />
                    </div>
                    
                    <div className="pt-2">
                         <button type="submit" className="btn-primary" disabled={isLoading}>
                            {isLoading ? 'Sending Link...' : 'Send Reset Link'}
                        </button>
                    </div>
                </form>

                <button
                    type="button"
                    className="auth-text-action auth-back-action"
                    onClick={() => navigate('/login')}
                >
                    <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
                    Back to log in
                </button>
            </div>
        </div>
    );
};

export default ForgotPassword;